import React from "react";
import styles from "./OnboardingStage.module.css";

const ShopifySync = ({ title = "Shopify Sync", stats = [], summary = "" }) => {
  if (!stats.length && !summary) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{title}</h3>

      {stats.length > 0 ? (
        <div className={styles.card}>
          <div className={styles.sectionHeader}>
            <span>S</span>
            <span className={styles.sectionLabel}>Sync Status</span>
          </div>
          {stats.map((item, index) => (
            <div key={`${item.key}-${index}`} className={styles.statsRow}>
              <span>{item.key}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ShopifySync;
